import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote", "link"],
    ["clean"],
  ],
};

export default function RichTextEditor({ value, onChange, placeholder }) {
  return (
    <div className="quill-wrap" data-testid="rich-editor">
      <ReactQuill theme="snow" value={value || ""} onChange={onChange} placeholder={placeholder} modules={modules} />
    </div>
  );
}
